var exports = {
  "YL": "Tooltip.module__tooltip___RjRUZ1",
  "xQ": "Tooltip.module__tooltipPointer___RjRUZ1",
  "rv": "Tooltip.module__tooltipContent___RjRUZ1",
  "iU": "Tooltip.module__tooltipContentLarge___RjRUZ1" + " " + "Tooltip.module__tooltipContent___RjRUZ1",
  "dn": "Tooltip.module__tooltipTop___RjRUZ1",
  "L_": "Tooltip.module__tooltipBottom___RjRUZ1",
  "Lf": "Tooltip.module__tooltipLeft___RjRUZ1",
  "Uu": "Tooltip.module__tooltipRight___RjRUZ1",
  "A4": "Tooltip.module__tooltipPrimary___RjRUZ1",
  "yH": "Tooltip.module__tooltipPointerBg___RjRUZ1",
  "Rp": "Tooltip.module__tooltipRed___RjRUZ1",
  "vX": "Tooltip.module__tooltips___RjRUZ1",
  "bZ": "Tooltip.module__hoverFloatingTooltipSurface___RjRUZ1",
  "IM": "Tooltip.module__triggerWrapper___RjRUZ1",
};

module.exports = exports;
